import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  getGuideById,
  createGuide,
  updateGuide,
  deleteGuide,
} from "../services/api";
import { TikTokEmbedLoader } from "../components/TikTokEmbedLoader";

function GuideForm() {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [contentMd, setContentMd] = useState("");
  const [tiktokEmbed, setTiktokEmbed] = useState("");
  const [isPublished, setIsPublished] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isEdit) {
      getGuideById(id)
        .then((res) => {
          const g = res.data;
          setTitle(g.title);
          setContentMd(g.content_md || "");
          setTiktokEmbed(g.tiktok_embed || "");
          setIsPublished(g.is_published || false);
        })
        .catch(() => setError("Không thể tải hướng dẫn."));
    }
  }, [id, isEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("content_md", contentMd);
      formData.append("tiktok_embed", tiktokEmbed);
      formData.append("is_published", isPublished);

      if (isEdit) {
        await updateGuide(id, formData);
        navigate("/cam-nang", { state: { message: "Cập nhật thành công!" } });
      } else {
        await createGuide(formData);
        navigate("/cam-nang", { state: { message: "Tạo mới thành công!" } });
      }
    } catch (err) {
      setError(err.response?.data?.error || "Đã có lỗi xảy ra");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Bạn chắc chắn muốn xoá hướng dẫn này?")) return;
    try {
      await deleteGuide(id);
      navigate("/cam-nang", { state: { message: "Xoá thành công!" } });
    } catch {
      setError("Xoá thất bại");
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-4 bg-white shadow rounded">
      <TikTokEmbedLoader />
      <h2 className="text-xl font-bold mb-4">
        {isEdit ? "Chỉnh sửa hướng dẫn" : "Tạo hướng dẫn mới"}
      </h2>

      {error && <div className="text-red-500 mb-2">{error}</div>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          className="w-full border p-2"
          placeholder="Tiêu đề hướng dẫn"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <textarea
          className="w-full border p-2 h-40"
          placeholder="Nội dung chi tiết (Markdown)"
          value={contentMd}
          onChange={(e) => setContentMd(e.target.value)}
        />

        <textarea
          className="w-full border p-2 h-40"
          placeholder="Nhúng TikTok (paste mã <blockquote>)"
          value={tiktokEmbed}
          onChange={(e) => setTiktokEmbed(e.target.value)}
          required
        />

        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={isPublished}
            onChange={(e) => setIsPublished(e.target.checked)}
          />
          <span>Xuất bản</span>
        </label>

        {tiktokEmbed && (
          <div className="mt-4">
            <div dangerouslySetInnerHTML={{ __html: tiktokEmbed }} />
          </div>
        )}

        <div className="flex space-x-4">
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            disabled={loading}
          >
            {loading ? "Đang lưu..." : "Lưu"}
          </button>
          {isEdit && (
            <button
              type="button"
              onClick={handleDelete}
              className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
            >
              Xoá
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export default GuideForm;